import axios from 'axios'

export const ExportTypes = {
  DailyReport: '/custom/e488b096-984a-4681-8561-b1527d715f4f',
  VehicleReport: '/custom/ad79468c-e37a-4c3b-ab41-9fc655023f8c',
}

export async function generateAndDownloadDailyReport(name, data) {
  const buffer = await generateExport({ type: ExportTypes.DailyReport, data })
  downloadAsXLSX(name, buffer)
}

export async function generateAndDownloadVehicleReport(name, data) {
  const buffer = await generateExport({ type: ExportTypes.VehicleReport, data })
  downloadAsXLSX(name, buffer)
}

export async function generateAndDownloadQualityReport(name, data) {
  const buffer = await generateExport({ data })
  downloadAsXLSX(name, buffer)
}

export async function generateExport({ type = '/xlsx', data } = {}) {
  if (!type) {
    throw new Error('missing export type')
  }
  if (!data) {
    throw new Error("can't export data of undefined")
  }

  const resp = await axios({
    url: `https://spreadsheet-generator.reges-services.se${type}`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Basic ' + process.env.SPREADSHEET_GENERATOR_API_KEY,
    },
    responseType: 'arraybuffer',
    data,
  })

  return resp.data
}

export function downloadAsXLSX(name, buffer) {
  download({
    name,
    buffer,
    mimeType:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
}

export function download({ mimeType, name, buffer }) {
  if (window.navigator.msSaveOrOpenBlob) {
    const blob = new Blob([buffer])
    window.navigator.msSaveOrOpenBlob(blob, name + '.xlsx')
  } else {
    const a = document.createElement('a')
    const blob = new Blob([buffer], {
      type: mimeType,
    })
    const url = URL.createObjectURL(blob)
    a.href = url
    a.target = '_blank'
    a.download = name + '.xlsx'
    document.body.appendChild(a)
    a.click()
    a.parentElement.removeChild(a)
  }
}
